import type { FaireProductEntity } from "../../entity_types/product";

export const p_awv3z7oh: FaireProductEntity = {
  token: "p_awv3z7oh",
  type: "product",
  name: "Golden Coast - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/768df07aec18697530ee2706135c459983a31c03444e9ebbb6588a7d14bb5cdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f780f3b53a23412830a986e544c1c384e2dea91816ead118e3f4ce8ae99300d.jpeg",
    "https://cdn.faire.com/fastly/5592cef24007b443aa60531d984c78d1cb3ab21786dffd1c1c1f27724ce1cac7.jpeg",
    "https://cdn.faire.com/fastly/33dc47d37698aed017cd2303808ec585cdfd016104910b6f319d1209f8fb2e0e.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Notes of eucalyptus, sea salt, redwood, and palo santo.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:56.580Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
